import React, { useState } from 'react'
import { useParams, useLocation } from 'react-router-dom';

import StudentDetailsLayout from '../layouts/Student';
import { TabContainer } from '../sub_components/Tabs';

import { useGetStudentDetails } from '../../hooks/students';
import { useGetStudentImmigrationDocuments } from '../../hooks/misc';

import Loader from '../reusables/Loader';

import Passport from '../sub_components/student/immigration/Passport';
import Permit from '../sub_components/student/immigration/Permit';
import Visa from '../sub_components/student/immigration/Visa';
import PROptions from './PROptions';

import { StudentImmigrationTab } from '../../interfaces/student';

const ImmigrationPage = () => {
    const location = useLocation();

    const { studentId: studentIdParam } = useParams();
    const studentId = studentIdParam ? parseInt(studentIdParam) : 0;

    const tabItems = [
        { id: 'Passport', label: 'Passport' },
        { id: 'Permit', label: 'Permit' },
        { id: 'Visa', label: 'Visa' },
        { id: 'PR Options', label: 'PR Options' }
    ];

    const [currentTab, setCurrentTab] = useState<StudentImmigrationTab>('Passport');

    const { data: student } = useGetStudentDetails(studentId);

    const { data, isLoading } = useGetStudentImmigrationDocuments(studentId);

    const handleTabChange = (tabId: string) => {
        setCurrentTab(tabId as StudentImmigrationTab);
    };

    return (
        <StudentDetailsLayout
            goBackRoute={location.state?.goBackRoute ?? null}
            operation='update'
            currentTab="Immigration"
            title={student?.first_name + ' ' + student?.last_name}
            error={false}
            linkedStatus={{
                isDataAvailable: !!studentId,
                linked: !!student?.date_linked,
                linkedDate: student?.date_linked ?? null,
                unlinkedDate: student?.date_unlinked ?? null,
            }}
            isStudentAdded={!!student}
        >
            <div className="immersion__common_details__sub_info_container">
                <div className='immersion__common_details__sub_info_view'>
                    <TabContainer
                        items={tabItems}
                        activeTab={currentTab}
                        onChange={handleTabChange}
                        variant="content"
                    />

                    <div className="immersion__common_details__sub_info__forms_container">
                        {isLoading && <div className='immersion__common_details__sub_info__forms_container__loading'>
                            <div className="immersion__common_details__sub_info__forms_container__loading__spinner">
                                <Loader text='Fetching data...' />
                            </div>
                        </div>}

                        {currentTab === 'Passport' &&
                            <Passport
                                studentId={studentId}
                                passports={data?.passports ?? []}
                                setCurrentTab={setCurrentTab}
                            />
                        }
                        {currentTab === 'Permit' &&
                            <Permit
                                studentId={studentId}
                                permits={data?.permits ?? []}
                                setCurrentTab={setCurrentTab}
                            />
                        }
                        {currentTab === 'Visa' &&
                            <Visa
                                studentId={studentId}
                                visas={data?.visas ?? []}
                                setCurrentTab={setCurrentTab}
                            />
                        }
                        {currentTab === 'PR Options' &&
                            <PROptions
                                studentId={studentId}
                                studentName={student?.first_name + ' ' + student?.last_name}
                                linked={!!student?.date_linked}
                            />
                        }
                    </div>
                </div>
            </div>
        </StudentDetailsLayout>
    )
}

export default ImmigrationPage;